import { render, staticRenderFns } from "./audio-player.vue?vue&type=template&id=6001d7d1&scoped=true"
import script from "./audio-player.vue?vue&type=script&lang=js"
export * from "./audio-player.vue?vue&type=script&lang=js"
import style0 from "./audio-player.vue?vue&type=style&index=0&id=6001d7d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6001d7d1",
  null
  
)

export default component.exports